import { render, staticRenderFns } from "./addStorageList.vue?vue&type=template&id=c4022504&scoped=true"
import script from "./addStorageList.vue?vue&type=script&lang=js"
export * from "./addStorageList.vue?vue&type=script&lang=js"
import style0 from "./addStorageList.vue?vue&type=style&index=0&id=c4022504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4022504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4022504')) {
      api.createRecord('c4022504', component.options)
    } else {
      api.reload('c4022504', component.options)
    }
    module.hot.accept("./addStorageList.vue?vue&type=template&id=c4022504&scoped=true", function () {
      api.rerender('c4022504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/stockManagement/toAuditReturn/addStorageList.vue"
export default component.exports